<template>
  <div class="box-header"><!-- v-if="$route.meta.showAddHeader"-->
    <div class="left content_left">
      <slot name="content_left"></slot>
    </div>
    <div class="add-button content_right">
      <slot name="content_right"></slot>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import * as getData from '../service/getData'

  export default {
    data() {
      return {}
    },
    created() {
      //console.log(this.$route.matched)
      //console.log(this.$route)
    },
    props: [],
    computed: {},
    methods: {},
    components: {}
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .box-header {
    margin: 0;
    min-height: 40px;
    padding: 10px;
  }

  .breadcrumb-inner {
    flex: 5;
  }

  .content_left {
    float: left;
  }

  .content_right {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/header2.vue